import React from 'react';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Button as AdminButton } from 'react-admin';
import { Link } from 'react-router-dom';

// const useStyles = makeStyles((theme) => ({
//   container: {
//     display: 'flex', flexDirection: 'column', gap: '0.5em', margin: '1em',
//   },
//   searchInputContainer: {
//     padding: '2px 4px',
//     display: 'flex',
//     alignItems: 'center',
//     width: 400,
//   },
//   searchInput: {
//     marginLeft: theme.spacing(1),
//     flex: 1,
//   },
//   searchIconButton: {
//     padding: 5,
//   },
// }));

/**
 * Opens a dialog to associate several devices to a task
 * 
 * React context is used here to share state with the embedded table elements
 * 
 * Standard props are still used whenever only one component is making use of that and/or there 
 * is no forecast of that value being required by other components in the future
 */
function AssociazioneMassivaButton() {
  return (
    <AdminButton
      label="Associazione Massiva"
      component={Link}
      to={'/devices/associazioneMassiva'}
      color="primary"
    >
      <PlaylistAddIcon />
    </AdminButton >
  );
}

export default AssociazioneMassivaButton;
